import { LeafCheckbox } from "./checkbox.component.js";
customElements.define("leaf-checkbox", LeafCheckbox);
export {
  LeafCheckbox
};
//# sourceMappingURL=checkbox.js.map
